import * as i0 from '@angular/core';
import { NgModule, PLATFORM_ID, Injectable, Inject, InjectionToken, Optional, makeStateKey } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule, isPlatformBrowser, PlatformLocation, APP_BASE_HREF } from '@angular/common';
import { LOCATION_TOKEN, WINDOW_TOKEN } from '@usana/ux/common';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

class UsanaSsrModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UsanaSsrModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: UsanaSsrModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UsanaSsrModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UsanaSsrModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [
                    // PlatformService
                    ],
                }]
        }] });

// todo see if this can be not root?
class PlatformService {
    constructor(platformId) {
        this.platformId = platformId;
    }
    isBrowser() {
        return isPlatformBrowser(this.platformId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformService, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }] });

class PlatformWrappedStorageService {
    constructor(platformService) {
        this.platformService = platformService;
    }
    hasStorage() {
        return this.platformService.isBrowser() && !!Storage;
    }
    sessionStorage() {
        return this.hasStorage() ? sessionStorage : null;
    }
    localStorage() {
        return this.hasStorage() ? localStorage : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedStorageService, deps: [{ token: PlatformService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: PlatformService }] });

class UsanaSsrRequest {
}

const USANA_SSR_REQUEST = new InjectionToken('ssr.request');

class PlatformWrappedLocationService {
    constructor(platformService, location, request, platformLocation, appBaseHref) {
        this.platformService = platformService;
        this.location = location;
        this.request = request;
        if (this.platformService.isBrowser() && platformLocation) {
            this.baseHref = platformLocation.getBaseHrefFromDOM();
        }
        else {
            this.baseHref = appBaseHref || '';
        }
    }
    href() {
        if (this.platformService.isBrowser()) {
            return this.location.href;
        }
        const theHref = `https://${this.request.hostname}${this.request.url}`;
        return theHref;
    }
    protocol() {
        if (this.platformService.isBrowser()) {
            return this.location.protocol;
        }
        return 'https:'; // backend should always be https
    }
    hostname() {
        if (this.platformService.isBrowser()) {
            return this.location.hostname;
        }
        return this.request.hostname;
    }
    port() {
        if (this.platformService.isBrowser()) {
            return this.location.port;
        }
        return ''; // backend should never have a port
    }
    pathname() {
        if (this.platformService.isBrowser()) {
            return this.location.pathname;
        }
        return this.request.url;
    }
    hash() {
        if (this.platformService.isBrowser()) {
            return this.location.hash;
        }
        return ''; // backend will never get sent the fragment so we have to assume its empty
    }
    assign(url) {
        if (this.platformService.isBrowser()) {
            this.location.assign(url);
        }
    }
    reload() {
        if (this.platformService.isBrowser()) {
            this.location.reload();
        }
    }
    replace(url) {
        if (this.platformService.isBrowser()) {
            this.location.replace(url);
        }
    }
    baseAppUrl() {
        return `${this.protocol()}//${this.hostname()}${this.baseHref}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedLocationService, deps: [{ token: PlatformService }, { token: LOCATION_TOKEN, optional: true }, { token: USANA_SSR_REQUEST, optional: true }, { token: PlatformLocation, optional: true }, { token: APP_BASE_HREF, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedLocationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedLocationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: PlatformService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [LOCATION_TOKEN]
                }] }, { type: UsanaSsrRequest, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [USANA_SSR_REQUEST]
                }] }, { type: i3.PlatformLocation, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [PlatformLocation]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [APP_BASE_HREF]
                }] }] });

class PlatformWrappedWindowService {
    constructor(platformService, window) {
        this.platformService = platformService;
        this.window = window;
    }
    getWindow() {
        if (this.platformService.isBrowser()) {
            return this.window;
        }
        return {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedWindowService, deps: [{ token: PlatformService }, { token: WINDOW_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedWindowService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedWindowService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: PlatformService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [WINDOW_TOKEN]
                }] }] });

class PlatformWrappedTransferStateService {
    constructor(transferState, platformService) {
        this.transferState = transferState;
        this.platformService = platformService;
    }
    loadStateOrObserve(key, loadDataObservable, overrideExistingState, defaultValue) {
        return this.loadStateKeyOrObserve(this.generateStateKey(key), loadDataObservable, overrideExistingState, defaultValue);
    }
    loadStateKeyOrObserve(stateKey, loadDataObservable, overrideExistingState, defaultValue) {
        const isServer = !this.platformService.isBrowser();
        // either we have the state key AND
        // a) we are the browser
        // b) we don't want to override existing state.
        if ((!isServer || !overrideExistingState) && this.hasStateKey(stateKey)) {
            // if we have a value in transfer state return it.
            return of(this.getStateKey(stateKey, defaultValue));
        }
        else {
            return loadDataObservable.pipe(tap((data) => {
                if (isServer) {
                    this.transferState.set(stateKey, data);
                }
            }));
        }
    }
    hasStateKey(key) {
        return this.transferState.hasKey(key);
    }
    removeStateKey(key) {
        this.transferState.remove(key);
    }
    getStateKey(key, defaultValue) {
        return this.transferState.get(key, defaultValue);
    }
    generateStateKey(key) {
        return makeStateKey(key);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedTransferStateService, deps: [{ token: i0.TransferState }, { token: PlatformService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedTransferStateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformWrappedTransferStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i0.TransferState }, { type: PlatformService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { PlatformService, PlatformWrappedLocationService, PlatformWrappedStorageService, PlatformWrappedTransferStateService, PlatformWrappedWindowService, USANA_SSR_REQUEST, UsanaSsrModule };
